import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import CONSTANTS from '../../constants';
import ImageHelper from '../../helpers/ImageHelper';
import ViewHelper from '../../helpers/ViewHelper';
import withBackButtonHandled from '../shared/WithBackButtonHandled';

const BinDiscountItems = (props) => {
  const getCurrentWidthViewPer = (width) => {

    if (width <= 450) {
      return 1.2;
    } else if (width <= 991) {
      return 1.3;
    } else if (width <= 1200) {
      return 1.5;
    } else if (width <= 1366) {
      return 3;
    } else {
      return 3;
    }
  };

  const getCurrentWidthSpaceBetween = (width) => {
    if (width <= 768) {
      return 14;
    } else {
      return 25;
    }
  };
  const bindiscountsTitles =
    props.bindiscounts && props._location
      ? ViewHelper.getCustomizedBinDiscountsTitles(props.bindiscounts, props._location)
      : [];
  const getDefaultTitleAndSubTitle = (promo_code) => {
    let promo_code_titles = {};
    let splited_promo;
    for (const promo_title of bindiscountsTitles) {
      splited_promo = promo_title.msg.split(':');
      if (parseInt(splited_promo[0]) === promo_code) {
        promo_code_titles.title = splited_promo[0];
        promo_code_titles.sub_title = splited_promo[1];
      }
    }
    return promo_code_titles;
  };
  const bindiscountsList = [];
  if (props.bindiscounts?.basket.length > 0) {
    for (const basketPromo of props.bindiscounts.basket) {
      bindiscountsList.push(basketPromo);
    }
  }

  if (props.bindiscounts?.all_items.length > 0) {
    props.bindiscounts.all_items.map((allItemPromo) => {
      bindiscountsList.push(allItemPromo);
    });
  }

  if (props.bindiscounts) {
    const catKeys = Object.keys(
      props.bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES]
    );
    const itemKeys = Object.keys(
      props.bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS]
    );
    if (itemKeys.length === 0) {
      if (catKeys.length > 0) {
        const catObj = props.bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES];
        let temp_promo_id = '';
        catKeys.map((categoryPromo, index) => {
          const prom = catObj[parseInt(catKeys[index])];
          if (temp_promo_id !== prom.bindiscount_discount_id) {
            bindiscountsList.push(prom);
            temp_promo_id = prom.bindiscount_discount_id;
          }
        });
      }
    }
  }
  if (props.bindiscounts) {
    const itemKeys = Object.keys(
      props.bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS]
    );
    if (itemKeys.length > 0) {
      const catObj = props.bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS];
      let temp_promo_id = '';
      itemKeys.map((itemPromo, index) => {
        const prom = catObj[parseInt(itemKeys[index])];
        if (temp_promo_id !== prom.bindiscount_discount_id) {
          bindiscountsList.push(prom);
          temp_promo_id = prom.bindiscount_discount_id;
        }
      });
    }
  }

  useEffect(() => {
    const parts = props.history.location.pathname.split('/');
    if (parts[2] === 'bindiscounts' && props._location.is_outlet) {
      props.showModal()
    }
  }, []);

  const redirectToBinModal = (link, item) => {
    props.showModal()
    return props.history.push(`${props._location.slug}/bindiscounts`);
  };
  const card_outline = props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : '';

  return (
    <>
      {bindiscountsList?.length > 0 && (
        <>
          <div className='d-flex justify-content-between'>
            <h4 class="f1 mb-2 custom-deals-name primary-font-color">BANK DISCOUNTS</h4>
            <h4 class="f1 mb-2 custom-deals-name highlight-color fs-6 pe-4" style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={redirectToBinModal}>see all</h4>
          </div>
          <div
            className={
              props.category_length === 1
                ? 'promotional-items promotional-item-without-category'
                : 'promotional-items'
            }
          >
            <Swiper
              // style={{display:"none"}}
              pagination={{
                clickable: true
              }}
              modules={bindiscountsList.length > 3 && [Pagination]}
              // breakpoints={promotionalBreakpoints}
              spaceBetween={getCurrentWidthSpaceBetween(props.currentWidth)}
              slidesPerView={getCurrentWidthViewPer(props.currentWidth)}
            >
              {bindiscountsList.filter(bin => getDefaultTitleAndSubTitle(bin.id).title).map((bindiscount) => {

                return (
                  <SwiperSlide>
                    {getDefaultTitleAndSubTitle(bindiscount.id).title && (
                      <div
                        className={`promotional-items__bincard default-bg mt-1`}
                        key={bindiscount.id}
                      >
                        <div className={`promotional-items__bincontents hovernowshodow ${card_outline}`}>
                          <img
                            className='binimg'
                            src={
                              ImageHelper.getImageURL(
                                bindiscount.bank_img_url,
                                '?func=crop&w=400&h=400'
                              )
                            }
                            style={{ width: '100px', height: '100px' }}
                            alt=""
                          />
                          <div className="promotional-items__bincontents__data">

                            <div className={'promotional-items__bincontents__data__sub-title mb-1'}>
                              {/* {getDefaultTitleAndSubTitle(bindiscount.code.toUpperCase()).title} */}
                              {ReactHtmlParser(getDefaultTitleAndSubTitle(bindiscount.id).sub_title)}

                            </div>
                            <h3 className={'promotional-items__bincontents__data__sub-title-title card-subtitle-color'}>
                              Terms & Conditions Apply
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}

                  </SwiperSlide>

                );
              }).slice(0, 5)}
            </Swiper>
          </div>
        </>
      )}
    </>
  );
};

function mapStateToProps(state) {
  const { bindiscounts, locationSettings } = state;
  return {
    bindiscounts,
    locationSettings
  };
}

export default withRouter(connect(mapStateToProps, {})(withBackButtonHandled(BinDiscountItems, (props) => { })));
